import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "splash-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key" }),
  /*#__PURE__*/_createTextVNode(" Reset Password")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "text-center"
}
const _hoisted_4 = {
  class: "alert alert-success rounded mt-3",
  role: "alert"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "lead text-white" }, "To reset your password, please enter your Email Address.", -1)
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "emailAddress",
  class: "form-label text-white"
}, "Email Address", -1)
const _hoisted_10 = ["readonly"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Find User")
const _hoisted_12 = {
  key: 0,
  class: "form-group"
}
const _hoisted_13 = {
  for: "challenge",
  class: "form-label text-white"
}
const _hoisted_14 = {
  key: 1,
  class: "form-group"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "ssn",
  class: "form-label text-white"
}, "Please enter your Social Security Number", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "date",
  class: "form-label text-white mt-2"
}, "Please enter your Date of Birth", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Send Password Reset Email")
const _hoisted_18 = { key: 3 }
const _hoisted_19 = {
  key: 1,
  class: "alert alert-warning text-dark rounded text-center"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-2x fa-exclamation-triangle mb-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "You have exceeded the allowable number of security question attempts. Please try again later.", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_activity_button = _resolveComponent("activity-button")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      (_ctx.model.submitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, " Password reset email sent to " + _toDisplayString(_ctx.model.emailAddress) + " Please check your spam and/or junk folders for the Password Reset email if not found in your Inbox. ", 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (!_ctx.tooManyFailures)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.model.emailAddress = $event)),
                      class: "form-control",
                      readonly: _ctx.model.userFound
                    }, null, 8, _hoisted_10), [
                      [
                        _vModelText,
                        _ctx.model.emailAddress,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    (!_ctx.model.userFound)
                      ? (_openBlock(), _createBlock(_component_activity_button, {
                          key: 0,
                          class: "btn btn-primary w-100 mt-2",
                          clickHandler: _ctx.search
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }, 8, ["clickHandler"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.model.challenge?.challengeType === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.model.challenge.prompt), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.model.challengeResponse = $event)),
                          class: "form-control"
                        }, null, 512), [
                          [_vModelText, _ctx.model.challengeResponse]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.model.challenge?.challengeType === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _withDirectives(_createElementVNode("input", {
                          id: "ssn",
                          type: "text",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.model.ssn = $event)),
                          class: "form-control"
                        }, null, 512), [
                          [_vModelText, _ctx.model.ssn],
                          [_directive_maska, '###-##-####']
                        ]),
                        _hoisted_16,
                        _withDirectives(_createElementVNode("input", {
                          id: "date",
                          type: "date",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.model.dateOfBirth = $event)),
                          class: "form-control"
                        }, null, 512), [
                          [_vModelText, _ctx.model.dateOfBirth]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.validEmail && _ctx.model.userFound)
                    ? (_openBlock(), _createBlock(_component_activity_button, {
                        key: 2,
                        class: _normalizeClass([{'btn-primary': _ctx.canSubmit, 'btn-secondary': !_ctx.canSubmit}, "btn w-100 mt-1"]),
                        disabled: !_ctx.canSubmit,
                        clickHandler: _ctx.sendPasswordResetEmail
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }, 8, ["class", "disabled", "clickHandler"]))
                    : _createCommentVNode("", true),
                  (_ctx.model.challengeAttemptResult)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.model.challengeAttemptResult), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))
          ]))
    ])
  ]))
}